import React from 'react';
import { InstantMessagerParticipantEndpointScheme } from '../../model';
import ProfilePhoto from '../ProfilePhoto';

export function ImProfilePhoto(displayName: string, endpointScheme: InstantMessagerParticipantEndpointScheme, endpointServer: string, endpointId: string, className: string) {
  let photo = null
  if (endpointScheme === InstantMessagerParticipantEndpointScheme.IpfxExtension) {
    photo = <ProfilePhoto className={className} name={displayName} extension={{ id: endpointId, server: endpointServer }} />
  } else if (endpointScheme === InstantMessagerParticipantEndpointScheme.IpfxContact) {
    photo = <ProfilePhoto className={className} name={displayName} contact={{ id: endpointId, server: endpointServer }} />
  } else {
    photo = <ProfilePhoto className={className} name={displayName} />
  }
  return photo
}
